import { QueryClient } from '@tanstack/react-query';

/**
 * Create a singleton QueryClient instance for React Query
 * This is used with QueryClientProvider to manage server state
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
